import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ChatToggleButton from './components/ChatToggleButton';

const HIDDEN_PATHS = ['/elearning/exam', '/quiz', '/test'];
const CHATBOT_ID = '1oKLEfS7S0-AronUXFah_';
const DISMISS_KEY = 'chatWidgetDismissed';

function ChatbaseWidget() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [isDismissed, setIsDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === 'true',
  );
  const stateRef = useRef({ isOpen: false, isHiddenPage: false });
  const applyStateRef = useRef(() => {});

  useEffect(() => {
    if (!document.getElementById('chatbase-embed-script')) {
      const script = document.createElement('script');
      script.src = 'https://www.chatbase.co/embed.min.js';
      script.id = 'chatbase-embed-script';
      script.setAttribute('chatbotId', CHATBOT_ID);
      script.setAttribute('domain', 'www.chatbase.co');
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    const applyState = () => {
      const { isOpen: open, isHiddenPage: hidden } = stateRef.current;

      const nativeBtn = document.getElementById('chatbase-bubble-button');
      if (nativeBtn) {
        nativeBtn.style.setProperty('display', 'none', 'important');
      }

      const mobileIframe = document.querySelector('iframe[title="Chatbot"]');
      if (mobileIframe) {
        if (hidden || !open) {
          mobileIframe.style.setProperty('display', 'none', 'important');
        } else {
          mobileIframe.style.removeProperty('display');
        }
      }
    };

    applyStateRef.current = applyState;

    const observer = new MutationObserver(() => {
      const nativeBtn = document.getElementById('chatbase-bubble-button');
      if (nativeBtn) {
        const expanded = nativeBtn.getAttribute('aria-expanded') === 'true';
        setIsOpen((prev) => (prev !== expanded ? expanded : prev));
      }
      applyState();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'aria-expanded'],
    });

    applyState();
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const isHiddenPage = HIDDEN_PATHS.some((path) => location.pathname.startsWith(path));
    stateRef.current = { isOpen, isHiddenPage };
    applyStateRef.current();

    if (isHiddenPage && isOpen) {
      window.chatbase?.close();
      setIsOpen(false);
    }
  }, [location.pathname, isOpen]);

  const handleOpenChat = () => {
    window.chatbase?.open();
    setIsOpen(true);
  };

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem(DISMISS_KEY, 'true');
  };

  const handleUndismiss = () => {
    setIsDismissed(false);
    sessionStorage.removeItem(DISMISS_KEY);
  };

  const isHiddenPage = HIDDEN_PATHS.some((path) => location.pathname.startsWith(path));

  if (isHiddenPage) return null;

  return (
    <ChatToggleButton
      isOpen={isOpen}
      isDismissed={isDismissed}
      onOpenChat={handleOpenChat}
      onDismiss={handleDismiss}
      onUndismiss={handleUndismiss}
    />
  );
}

export default ChatbaseWidget;
